import React from "react";
import {
  DataGrid,
  Summary,
  TotalItem,
  Column,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import axios from "../api-axios";
import UserInfo from "../UserInfo";

export default class PainelImobiliarioBox extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    axios
      .post(`/paineis/painel_imobiliario/${UserInfo.getPrefeitura()}`)
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.imoveisBairros
        ) {
          this.setState(response.data.imoveisBairros);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        {console.log(this.state)}
        <DataGrid
          dataSource={this.state.bairros}
          showBorders={true}
          rowAlternationEnabled={true}
          remoteOperations={true}
          wordWrapEnabled={true}
        >
          <Column dataField={"nome"} caption={"Bairro"} />
          <Column dataField={"qtdePredial"} caption={"Natureza Predial"} />
          <Column
            dataField={"qtdeTerritorial"}
            caption={"Natureza Territorial"}
          />
          <Column dataField={"qtdeTotal"} caption={"Total"} />
          <Summary>
            <TotalItem
              column="nome"
              customizeText={() => {
                return "Total";
              }}
            />
            <TotalItem
              column="qtdePredial"
              customizeText={() => {
                return `${this.state.totalPredialGeral}`;
              }}
            />
            <TotalItem
              column="qtdeTerritorial"
              customizeText={() => {
                return `${this.state.totalTerritorialGeral}`;
              }}
            />
            <TotalItem
              column="qtdeTotal"
              customizeText={() => {
                return `${this.state.totalGeral}`;
              }}
            />
          </Summary>
          <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
          />
        </DataGrid>
      </div>
    );
  }
}
